<template>
    <div>
        <el-row >
            <el-col :span="6">
                <span style="font-size:12px;color:rgba(0, 0, 0, 0.7)">说明：该模块配置小程序首页店铺详情内容，图片会按上传的顺序进行排列</span>
            </el-col>
            <el-col :span="6">
                <el-button type="primary"  @click="saveShopPicture()">保存</el-button>
            </el-col>
        </el-row>
         <el-upload
            style="margin-top:30px"
            action=""
            multiple
            ref="detailPic"
             :file-list="tableData"
            list-type="picture-card"
            :http-request="(param) => handleDetailPicRequest(param)"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
      return {
         uploadUrl: 'file/upload', //图片上传地址
         tableData:[],
         dialogImageUrl: '',
         dialogVisible: false,
      }
    },
    created() {
        this.getShopPictureList();
    },
    methods: {
        async getShopPictureList(){
            const res = await this.$axios.post('manage/config/getShopPictureList')
            if(res.data.code == 0){
                this.tableData = res.data.data
            }else{
                this.$message.error(`${res.data.msg}`);
            }
        },
        handleRemove(file, fileList) {
            this.tableData = fileList
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
       },
        async handleDetailPicRequest(param) {
            const formData = new FormData();
            formData.append('file', param.file);
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const res = await this.$axios.post(this.uploadUrl, formData, config);
            if (res.data.code == 0) {
                this.tableData.push(res.data.data)
                console.log(this.tableData)
            } else {
                this.$message.error(res.data.msg);
            }
        },
        async saveShopPicture() {
            const res = await this.$axios.post('manage/config/updateShopPicture',this.tableData)
            if(res.data.code == 0){
                this.$message.success('保存成功');
            }else{
                this.$message.error(`${res.data.msg}`);
            }
        }
    }
}
</script>

<style>
</style>